import React, { Component } from 'react';
import {
    Container,
    Box,
    Typography,
    Button,
    IconButton,
    CircularProgress,
    Card,
    CardContent,
    CardMedia,
    Link as MuiLink
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { singlePost, remove, like, unlike } from './apiPost';
import DefaultPost from '../images/mountains.jpg';
import { Link, Redirect } from 'react-router-dom';
import { isAuthenticated } from '../auth';
import Comment from './Comment';

class SinglePost extends Component {
    state = {
        post: '',
        redirectToHome: false,
        redirectToSignin: false,
        like: false,
        likes: 0,
        comments: []
    };

    checkLike = likes => {
        const userId = isAuthenticated() && isAuthenticated().userId;        

        let match = likes.indexOf(userId) !== -1;
        return match;
    };

    componentDidMount = () => {
        const postId = this.props.match.params.postId;
        singlePost(postId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    post: data,
                    likes: data.likes.length,
                    like: this.checkLike(data.likes),
                    comments: data.comments
                });
            }
        });
    };

    updateComments = comments => {
        this.setState({ comments });
    };

    likeToggle = () => {
        if (!isAuthenticated()) {
            this.setState({ redirectToSignin: true });
            return false;
        }
        let callApi = this.state.like ? unlike : like;
        const userId = isAuthenticated().userId;
        const postId = this.state.post._id;
        const token = isAuthenticated().token;

        callApi(userId, token, postId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    like: !this.state.like,
                    likes: data.likes.length
                });
            }
        });
    };

    deletePost = () => {
        const postId = this.props.match.params.postId;
        const token = isAuthenticated().token;
        remove(postId, token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ redirectToHome: true });
            }
        });
    };

    deleteConfirmed = () => {
        let answer = window.confirm('Are you sure you want to delete your post?');
        if (answer) {
            this.deletePost();
        }
    };

    renderPost = post => {
        const posterId = post.postedBy ? `/user/${post.postedBy._id}` : '';
        const posterName = post.postedBy ? post.postedBy.name : ' Unknown';

        const { like, likes } = this.state;

        return (
            <Box>
                <CardMedia
                    component="img"
                    height="300"
                    image={`${process.env.REACT_APP_API_URL}/post/photo/${post._id}`}
                    alt={post.title}
                    onError={(e) => {
                        e.target.src = DefaultPost;
                    }}
                    sx={{ mb: 3, objectFit: 'cover' }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, cursor: 'pointer' }} onClick={this.likeToggle}>
                    <IconButton color={like ? "success" : "default"}>
                        <ThumbUpIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ ml: 1 }}>
                        {likes} Like
                    </Typography>
                </Box>

                <Typography variant="body1" paragraph>
                    {post.body}
                </Typography>

                <Typography variant="body2" sx={{ fontStyle: 'italic', backgroundColor: '#fff3cd', p: 1, borderRadius: 1, mb: 2 }}>
                    Posted by <MuiLink component={Link} to={`${posterId}`} underline="hover">{posterName}</MuiLink>
                    {' '}on {new Date(post.created).toDateString()}
                </Typography>

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Button component={Link} to={`/`} variant="contained" color="primary" size="small">
                        Back to posts
                    </Button>

                    {isAuthenticated().user && isAuthenticated().userId === post.postedBy._id && (
                        <>
                            <Button component={Link} to={`/post/edit/${post._id}`} variant="contained" color="warning" size="small">
                                Update Post
                            </Button>
                            <Button onClick={this.deleteConfirmed} variant="contained" color="error" size="small">
                                Delete Post
                            </Button>
                        </>
                    )}

                    {isAuthenticated().user && isAuthenticated().role === 'admin' && (
                        <Card sx={{ mt: 3, width: '100%' }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>Admin</Typography>
                                <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                                    Edit/Delete as an Admin
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Button
                                        component={Link}
                                        to={`/post/edit/${post._id}`}
                                        variant="contained"
                                        color="warning"
                                        size="small"
                                    >
                                        Update Post
                                    </Button>
                                    <Button onClick={this.deleteConfirmed} variant="contained" color="error" size="small">
                                        Delete Post
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    )}
                </Box>
            </Box>
        );
    };

    render() {
        const { post, redirectToHome, redirectToSignin, comments } = this.state;

        if (redirectToHome) {
            return <Redirect to={`/`} />;
        } else if (redirectToSignin) {
            return <Redirect to={`/signin`} />;
        }

        return (
            <Container>
                <Typography variant="h3" sx={{ mt: 5, mb: 5 }}>
                    {post.title}
                </Typography>

                {!post ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                        <Box sx={{ textAlign: 'center' }}>
                            <CircularProgress sx={{ mb: 2 }} />
                            <Typography variant="h5">Loading...</Typography>
                        </Box>
                    </Box>
                ) : (
                    this.renderPost(post)
                )}

                <Comment postId={post._id} comments={comments.reverse()} updateComments={this.updateComments} />
            </Container>
        );
    }
}

export default SinglePost;